// ── TAYRO SHOPIFY JS ───────────────────────────────────────
// Integrates with Shopify AJAX Cart API for real cart functionality
// Falls back to local cart for demo/preview mode

const SHOPIFY_MODE = (typeof Shopify !== 'undefined');

// ── HELPERS ─────────────────────────────────────────────────
var HTML_ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
HTML_ESC[String.fromCharCode(34)] = '&quot;';
HTML_ESC[String.fromCharCode(39)] = '&#39;';
var HTML_ESC_RE = new RegExp('[&<>' + String.fromCharCode(34, 39) + ']', 'g');

function escapeHtml(s) {
  return String(s).replace(HTML_ESC_RE, function (c) { return HTML_ESC[c]; });
}

// Cart line label: combined products (e.g. '... - Dark Colors') read as one name,
// and options show Size first, then Color.
function cartLineLabel(item) {
  var opts = (item.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; });
  var hasColor = opts.some(function (o) { return /colou?r/i.test(o.name); });
  var name = item.product_title || '';
  if (hasColor && name.indexOf(' - ') > 0) name = name.substring(0, name.indexOf(' - '));
  opts = opts.slice().sort(function (a, b) {
    return (/size/i.test(b.name) ? 1 : 0) - (/size/i.test(a.name) ? 1 : 0);
  });
  var variant = opts.map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
  return { name: name, variant: variant };
}

// ── SHOPIFY AJAX CART ─────────────────────────────────────────
async function addToCart(variantId, name, cat, price, btn) {
  if (!variantId) {
    addCartStatic(name, cat, price);
    return;
  }
  let prevText;
  if (btn) { prevText = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…'; }
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: 'id=' + encodeURIComponent(variantId) + '&quantity=1'
    });
    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.description || errData.message || ('Cart add failed (' + response.status + ')'));
    }
    await refreshCart();
    toast(name + ' added to cart');
    openCart();
  } catch (err) {
    console.error('Shopify cart error:', err);
    if (!SHOPIFY_MODE) {
      addCartStatic(name, cat, price);
    } else {
      toast('Could not add: ' + (err.message || 'please try again'));
    }
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = prevText; }
  }
}

async function refreshCart() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    renderShopifyCart(cart);
  } catch (err) {
    console.error('Cart refresh error:', err);
  }
}

async function updateCartItem(key, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    await refreshCart();
  } catch (err) {
    console.error('Cart update error:', err);
  }
}

function shipMsgHtml(total) {
  const remaining = 75 - total;
  return remaining > 0
    ? `Add <strong>$${remaining.toFixed(2)}</strong> more for <span class='free-ship'>free shipping</span>`
    : `<span class='free-ship'>✓ You've unlocked free shipping!</span>`;
}

const EMPTY_CART_HTML = `<div class='drawer-empty'><div class='big-icon'>🛍️</div><p>Your cart is empty.<br/>Add something to get started.</p></div>`;

function renderShopifyCart(cartData) {
  const count = cartData.item_count;
  const total = cartData.total_price / 100;
  document.getElementById('cart-chip').textContent = count;

  const body = document.getElementById('drawer-body');
  const foot = document.getElementById('drawer-foot');

  if (!cartData.items || cartData.items.length === 0) {
    body.innerHTML = EMPTY_CART_HTML;
    foot.style.display = 'none';
    return;
  }

  body.innerHTML = cartData.items.map(item => {
    const label = cartLineLabel(item);
    return `
    <div class='cart-item'>
      <div class='ci-img'>
        ${item.image ? `<img src='${item.image}' alt='${escapeHtml(label.name)}' style='width:100%;height:100%;object-fit:cover;border-radius:6px;'>` : '🛍️'}
      </div>
      <div class='ci-info'>
        <div class='ci-name'>${escapeHtml(label.name)}</div>
        ${label.variant ? `<div class='ci-variant' style='font-size:12px;color:var(--ash);margin:2px 0 4px;'>${escapeHtml(label.variant)}</div>` : ''}
        <div class='ci-price'>$${(item.price / 100).toFixed(2)} each</div>
        <div class='ci-qty'>
          <button class='q-btn' onclick='updateCartItem(&quot;${item.key}&quot;, ${item.quantity - 1})'>−</button>
          <span class='q-num'>${item.quantity}</span>
          <button class='q-btn' onclick='updateCartItem(&quot;${item.key}&quot;, ${item.quantity + 1})'>+</button>
          <button class='ci-remove' onclick='updateCartItem(&quot;${item.key}&quot;, 0)'>Remove</button>
        </div>
      </div>
    </div>`;
  }).join('');

  foot.style.display = 'block';
  document.getElementById('drawer-total').textContent = '$' + total.toFixed(2);
  document.getElementById('ship-msg').innerHTML = shipMsgHtml(total);
}

function goCheckout() {
  window.location.href = '/checkout';
}

// ── STATIC / FALLBACK CART ────────────────────────────────────
// Used when no Shopify products are set up yet, or in preview
let staticCart = [];

function addCartStatic(name, cat, price) {
  const existing = staticCart.find(i => i.name === name);
  if (existing) { existing.qty += 1; }
  else { staticCart.push({ name, cat, price, qty: 1, icon: catIcon(cat) }); }
  renderStaticCart();
  toast(name + ' added to cart');
  openCart();
}

function catIcon(c) {
  return { cover: '⛳', brush: '🖌️', glove: '🧤', grip: '🏌️', hat: '🧢' }[c] || '🛍️';
}

function changeQty(name, d) {
  const i = staticCart.find(x => x.name === name);
  if (!i) return;
  i.qty += d;
  if (i.qty <= 0) staticCart = staticCart.filter(x => x.name !== name);
  renderStaticCart();
}

function removeItem(name) {
  staticCart = staticCart.filter(x => x.name !== name);
  renderStaticCart();
}

function renderStaticCart() {
  const total = staticCart.reduce((s, i) => s + i.price * i.qty, 0);
  const count = staticCart.reduce((s, i) => s + i.qty, 0);
  document.getElementById('cart-chip').textContent = count;

  const body = document.getElementById('drawer-body');
  const foot = document.getElementById('drawer-foot');

  if (!staticCart.length) {
    body.innerHTML = EMPTY_CART_HTML;
    foot.style.display = 'none';
  } else {
    body.innerHTML = staticCart.map((i, n) => `
      <div class='cart-item'>
        <div class='ci-img'>${i.icon}</div>
        <div class='ci-info'>
          <div class='ci-name'>${escapeHtml(i.name)}</div>
          <div class='ci-price'>$${i.price}.00 each</div>
          <div class='ci-qty'>
            <button class='q-btn' onclick='changeQty(staticCart[${n}].name,-1)'>−</button>
            <span class='q-num'>${i.qty}</span>
            <button class='q-btn' onclick='changeQty(staticCart[${n}].name,1)'>+</button>
            <button class='ci-remove' onclick='removeItem(staticCart[${n}].name)'>Remove</button>
          </div>
        </div>
      </div>`).join('');

    foot.style.display = 'block';
    document.getElementById('drawer-total').textContent = '$' + total.toFixed(2);
    document.getElementById('ship-msg').innerHTML = shipMsgHtml(total);
  }
}

// ── CART DRAWER ───────────────────────────────────────────────
function openCart() {
  // Refresh from Shopify only when the static fallback cart isn't in use
  if (SHOPIFY_MODE && staticCart.length === 0) { refreshCart(); }
  document.getElementById('overlay').classList.add('on');
  document.getElementById('drawer').classList.add('on');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  document.getElementById('overlay').classList.remove('on');
  document.getElementById('drawer').classList.remove('on');
  document.body.style.overflow = '';
}

// ── CATEGORY FILTER ───────────────────────────────────────────
function filter(cat, btn) {
  document.querySelectorAll('.cat-btn').forEach(b => b.classList.remove('on'));
  btn.classList.add('on');
  const cards = document.querySelectorAll('.p-card');
  let shown = 0;
  cards.forEach(c => {
    const cats = c.dataset.cat || '';
    const show = cat === 'all' || cats.includes(cat);
    c.style.display = show ? 'flex' : 'none';
    if (show) shown++;
  });
  const countEl = document.getElementById('product-count');
  if (countEl) countEl.textContent = `Showing ${shown} product${shown !== 1 ? 's' : ''}`;
}

// ── PREDICTIVE SEARCH ─────────────────────────────────────────
let searchDebounce;
let searchOpen = false;

function toggleSearch() {
  searchOpen ? closeSearch() : openSearch();
}

function openSearch() {
  searchOpen = true;
  document.getElementById('search-panel').classList.add('on');
  document.getElementById('search-backdrop').classList.add('on');
  document.getElementById('search-panel').setAttribute('aria-hidden', 'false');
  document.getElementById('search-toggle').setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
  setTimeout(() => document.getElementById('search-input').focus(), 250);
}

function closeSearch() {
  searchOpen = false;
  document.getElementById('search-panel').classList.remove('on');
  document.getElementById('search-backdrop').classList.remove('on');
  document.getElementById('search-panel').setAttribute('aria-hidden', 'true');
  document.getElementById('search-toggle').setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}

function runPredictiveSearch(query) {
  const results = document.getElementById('search-results');
  if (!query || query.trim().length < 2) {
    results.innerHTML = '';
    return;
  }

  results.innerHTML = `<div class='sr-loading'>Searching…</div>`;

  const url = '/search/suggest.json?q=' + encodeURIComponent(query)
    + '&resources[type]=product&resources[limit]=6'
    + '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';

  fetch(url, { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(data => {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      renderSearchResults(products, query);
    })
    .catch(err => {
      console.error('Search error:', err);
      results.innerHTML = `<div class='sr-empty'>Search is unavailable right now. Press Enter to search the full store.</div>`;
    });
}

function renderSearchResults(products, query) {
  const results = document.getElementById('search-results');
  const q = escapeHtml(encodeURIComponent(query));

  if (!products.length) {
    results.innerHTML = `<div class='sr-empty'>No products found for “${escapeHtml(query)}.”<br>Try a different term.</div>`
      + `<a class='sr-viewall' href='/search?q=${q}'>Search the full store →</a>`;
    return;
  }

  // Combined products (e.g. '... - Dark Colors' / '... - Light Colors') show once
  const seen = {};
  let html = `<div class='sr-section-label'>Products</div>`;
  html += products.map(p => {
    let title = String(p.title || '');
    if (title.indexOf(' - ') > 0 && /colou?rs?$/i.test(title)) title = title.substring(0, title.indexOf(' - '));
    const key = title.toLowerCase();
    if (seen[key]) return '';
    seen[key] = true;
    const img = p.featured_image && p.featured_image.url
      ? `<img src='${p.featured_image.url}' alt='${escapeHtml(title)}'>`
      : '⛳';
    const price = p.price ? formatMoney(p.price) : '';
    const type = p.type || (p.product_type || '');
    return `<a class='sr-item' href='${p.url}'>`
      + `<div class='sr-thumb'>${img}</div>`
      + `<div class='sr-info'>`
      + `<div class='sr-title'>${escapeHtml(title)}</div>`
      + (type ? `<div class='sr-meta'>${escapeHtml(type)}</div>` : '')
      + `</div>`
      + (price ? `<div class='sr-price'>${price}</div>` : '')
      + `</a>`;
  }).join('');
  html += `<a class='sr-viewall' href='/search?q=${q}'>View all results →</a>`;
  results.innerHTML = html;
}

function formatMoney(cents) {
  // suggest.json returns price as a string like '44.00' or sometimes cents; normalize
  const n = typeof cents === 'string' ? parseFloat(cents) : cents / 100;
  if (isNaN(n)) return '';
  return '$' + n.toFixed(2).replace(/[.]00$/, '');
}

// ── TOAST ─────────────────────────────────────────────────────
let toastTimer;
function toast(msg) {
  const el = document.getElementById('toast');
  document.getElementById('toast-msg').textContent = msg;
  el.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('show'), 2600);
}

// ── QUICK ADD (delegated, survives apostrophes in titles) ───
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var vid = btn.getAttribute('data-variant-id');
  if (!vid) { toast('This item is currently unavailable'); return; }
  addToCart(vid, btn.getAttribute('data-title') || 'Item', btn.getAttribute('data-cat') || 'all', 0, btn);
});

// ── INIT ──────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  if (SHOPIFY_MODE) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const chip = document.getElementById('cart-chip');
        if (chip) chip.textContent = cart.item_count;
      })
      .catch(() => {});
  }

  const searchInput = document.getElementById('search-input');
  if (searchInput) {
    searchInput.addEventListener('input', e => {
      clearTimeout(searchDebounce);
      const q = e.target.value;
      searchDebounce = setTimeout(() => runPredictiveSearch(q), 220);
    });
    searchInput.addEventListener('keydown', e => {
      if (e.key === 'Enter' && e.target.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(e.target.value.trim());
      }
    });
  }

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      if (searchOpen) closeSearch();
      closeCart();
    }
  });
});
